import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'
import types from '../types/sign-up.types'
import SignInfo from '../lib/signInfo'
const name = 'sign-up'

export default {
  name,
  namespaced: true,
  state() {
    return {
      courseId: '', // 课程id
      courseInfo: {}, // 课程信息(接口返回)
      tabs: [], // 切换
      tabIndex: 0, // 当前切换值
      images: [], // 图片介绍
      schedules: {}, // 目录
      hasBuy: false, // 是否已购买
      tryInfo: {}, // 试看信息
      priceInfo: {}, // 价格信息
      groupEndTime: [], // 组团结束时间
      groupLists: [], // 当前拼团列表
      pingAble: (navigator.userAgent.toLowerCase().match(/MicroMessenger/i) || '').toString() === 'micromessenger',
      isSubscribe: 1,
      biggestCoupon: 0,
      hasTry: 0,
      isRetain: 0,
      signInfo: {},
      loading: false
    }
  },
  getters: {
    isVip(state, getters, r) {
      return r.isVip
    },

    redirectFlag(state, getters, r) {
      return r.redirectFlag
    }
  },
  mutations: {
    set(state, data) {
      assign(state, data)
    },
    tab(state, data) {
      state.tabIndex = data
    },
    [types.SET_COURSE_INFO](state, data) {
      state.courseInfo = data
    },
    [types.SET_TRY_INFO](state, data) {
      state.tryInfo = data
    },
    [types.SET_HAS_BUY](state, data) {
      state.hasBuy = data
    },
    [types.SET_PRICE_INFO](state, data) {
      state.priceInfo = data
    },
    [types.SET_IMAGES](state, data) {
      if (data.length) {
        state.images = data
        const hasTab = state.tabs.filter(item => item.name === '介绍').length
        if (!hasTab) {
          state.tabs.push({
            name: '介绍'
          })

          // 防止 tab 元素闪出“目录”条目，先将目录条目与“介绍”都放进 tabs
          state.tabs.push({
            name: '目录'
          })
        }
      }
    },
    [types.SET_SCHEDULES](state, data) {
      if (data.chapterList && data.chapterList.length) {
        state.schedules = data
        const hasTab = state.tabs.filter(item => item.name === '目录').length
        const hasTryResource = state.schedules.chapterList.filter(item => item.canTry === 1).length
        if (!hasTab) {
        state.tabs.push({
          name: '介绍'
        })
        state.tabs.push({
          name: '目录',
          hasTry: hasTryResource
        })
        }

        state.hasTry = hasTryResource
        // 根据工作流，“目录”的索引值应为 1
        // state.tabs[1].hasTry = hasTryResource
      }
    },
    toggleSpreadSchedule: (state, section) => {
      state.schedules.chapterList.forEach(item => {
        if (item.id === section.id) {
          item.isSpread = !item.isSpread
        }
      })
    },
    setSignUp(state, data) {
      data.cardList.map(val => {
        if (val.type === 1) {
          state.signInfo = val
        }
      })
      state.signInfo.signStatus = data.signStatus
    }
  },
  actions: {
    async checkVip({
      commit
    }) {
      const {
        data
      } = await api.mine.isVip()
      commit(global.SET_VIP_STATUS, data, {
        root: true
      })
    },

    async setTab({
      commit
    }, tabIndex) {
      commit('set', {
        tabIndex
      })
    },
    // 获取拼团列表
    async getGroupList({
      commit,
      rootState
    }) {
      const {
        data
      } = await api.signUp.getGroupList(rootState.route.query.courseId)()
      commit('set', {
        groupLists: data
      })
    },
    // 获取数据
    async 'data:get'({
      commit,
      rootState
    }) {
      const {
        courseId
      } = rootState.route.query
      if (!courseId) {
        return commit(global.ERR, '缺少课程 id', {
          root: true
        })
      }
      commit('set', {
        courseId
      })

      const {
        data: infoData
      } = await api.signUp.info({
        courseId
      })
      commit(types.SET_COURSE_INFO, infoData)
      commit(types.SET_TRY_INFO, {
        title: infoData.tryTitle || infoData.title,
        image: infoData.tryImage,
        audioUrl: infoData.tryType === 2 ? infoData.tryUrl : '',
        audioLength: infoData.length,
        videoUrl: infoData.tryType === 1 ? infoData.tryUrl : ''
      })
      commit(types.SET_HAS_BUY, infoData.enroll === 1)
      commit(types.SET_PRICE_INFO, buildPriceInfo(infoData))

      commit(types.SET_IMAGES, infoData.image)
      if (infoData.vipExclusiveFlag) {
        await SignInfo.getPrivilegeDetail()
        commit('setSignUp', SignInfo.state)
      }
      const {
        data: scheduleData
      } = await api.schedule.getData({
        courseId,
        position: 1
      })
      scheduleData.chapterList.forEach(item => (item.isSpread = true))
      commit(types.SET_SCHEDULES, scheduleData)
    },
    async getRetain({
      commit,
      state
    }) {
      try {
        const {
          data
        } = await api.course.getRetain(state.courseId)()
        commit('set', {
          isRetain: data
        })
      } catch (e) {}
    },
    async subscribe({
      commit
    }) {
      const {
        data
      } = await api.signUp.isSubsribe()
      commit('set', {
        isSubscribe: data
      })
    },
    async rerender({
      dispatch,
      state
    }) {
      await dispatch('data:get')
      if (state.isSubscribe) {
        location.href = location.protocol + '//' + location.host + '/group?groupId=' + state.courseInfo.groupId
      } else {
        location.href = location.protocol + '//' + location.host + '/group-result?groupId=' + state.courseInfo.groupId
      }
    },
    async getCoupon({
      commit,
      state,
      rootState
    }) {
      let {
        data
      } = await api.payment.getCoupon({
        courseId: rootState.route.query.courseId,
        type: 1
      })
      try {
        if (data.length) {
          commit('set', {
            biggestCoupon: data[0].value
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    unsetRedirectFlag({
      commit
    }) {
      commit(global.UNSET_REDIRECT_FLAG, {}, {
        root: true
      })
    },
    // 标签统计
    async tagReport({
      rootState
    }) {
      const {
        courseId
      } = rootState.route.query

      try {
        await api.signUp.tagReport(courseId)()
      } catch (e) {}
    },
    // 初始化
    async init({
      commit,
      dispatch,
      state
    }, {
      query,
      loadingComponent
    }) {
      loadingComponent.show()
      await dispatch('data:get')

      commit('set', {
        loading: true
      })
      loadingComponent.hide()
      if (state.courseInfo.groupStatus !== -1) {
        await dispatch('getGroupList')
      }
      await dispatch('subscribe')
      await dispatch('getCoupon')
      await dispatch('checkVip')
      dispatch('getUserInfo', null, {
        root: true
      })
      dispatch('tagReport')
      // await dispatch('getRetain')
    }
  }
}

function buildPriceInfo(infoData) {
  const now = infoData.systemDate
  // 是否在活动期间
  const isInAct = now >= infoData.discountStartTime && now <= infoData.discountEndTime
  return {
    current: infoData.vipPrice || infoData.price,
    origin: infoData.price,
    vipPrice: infoData.vipPrice,
    vipDiscount: infoData.vipDiscount,
    marketPrice: infoData.marketPrice,
    price: infoData.price,
    activityPrice: isInAct ? infoData.discountPrice : false,
    isInAct
  }
}
